import { request } from "./request";

export function logout() {
  return request('post', process.env.API_URL + '/api/v1/auth/logout/').
  then(function (data) {
    localStorage.removeItem('ngStorage-authToken');
    localStorage.removeItem('ngStorage-authenticatedAccount');
    localStorage.removeItem('ngStorage-accountLastChecked');
    return data;
  });
}